import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getMessage } from 'util/locale';

import classNames from 'classnames';

// components
import TrialPlacements from './TrialPlacements';
import ProductApplicationRate from './ProductApplicationRateContainer';
import FailedToLoadContent from './FailedToLoadContent';
import TrialPlacementMapContainer from '../mapping/TrialPlacementMapContainer';

const baseString = 'vra-trial-placements-container';
class TrialPlacementsLoader extends Component {
  render() {
    const {
      stepNumber,
      areTrialPlacementsLoaded,
      onSelectTrialPlacements,
      fieldBoundary,
      trialPlacementOptions,
      selectedTrialPlacementsId
    } = this.props;
    const classString = classNames({
      [`${baseString}`]: true
    });
    let sideBarContent;

    switch (stepNumber) {
      case 2:
        sideBarContent = (<TrialPlacements
          fieldBoundary={fieldBoundary}
          onSelectTrialPlacements={onSelectTrialPlacements}
          selectedTrialPlacementsId={selectedTrialPlacementsId}
          trialPlacements={trialPlacementOptions}
        />);
        break;
      case 3:
        sideBarContent = (<ProductApplicationRate />);
        break;
      default:
        sideBarContent = <FailedToLoadContent />;
    }
    const content = areTrialPlacementsLoaded ? (
      <React.Fragment>
        {sideBarContent}
        <TrialPlacementMapContainer />
      </React.Fragment>
    ) : (
      <div className="loading-message">{getMessage('text__trial-placements--loading')}</div>
    );

    return (
      <section className={classString} data-test-id='script-trial-placement-selection'>
        {content}
      </section>
    );
  }
}

TrialPlacementsLoader.propTypes = {
  areTrialPlacementsLoaded: PropTypes.bool.isRequired,
  fieldBoundary: PropTypes.object.isRequired,
  onChangeProductApplicationRate: PropTypes.func.isRequired,
  onSelectTrialPlacements: PropTypes.func.isRequired,
  plantingPlanParams: PropTypes.object,
  scriptType: PropTypes.string.isRequired,
  selectedTrialPlacementsId: PropTypes.string,
  stepNumber: PropTypes.number.isRequired,
  trialPlacementOptions: PropTypes.array.isRequired
};

export default TrialPlacementsLoader;
